export default __webpack_public_path__ + "static/media/mobile.97475731.svg";